import { Injectable } from "@angular/core";
import { Location, LocationStrategy } from "@angular/common";
import { Router, NavigationEnd, RoutesRecognized, NavigationExtras } from "@angular/router";

import { filter, pairwise } from 'rxjs/operators';
 
declare const window: any;
@Injectable({ providedIn: "root" })
export class DWNavigationService {

  commonlib: any;
  private history: string[] = [];
  queryP: any = {};

  constructor(
    private router: Router,
    private location: Location,
    private locationStrate: LocationStrategy,
  ) {
    // ページ遷移イベント
    this.router.events
      .pipe(filter((e: any) => e instanceof RoutesRecognized),
          pairwise()
      ).subscribe((e: any) => {
        // console.log(">> router previous page :", e[0].urlAfterRedirects);
        // console.log(">> router current page :", e[1]?.urlAfterRedirects);
        // this.previousUrl = e[0].urlAfterRedirects;
        // if (this.previousUrl.includes('?')) {
        //   this.previousParam = this.previousUrl.split('?')[1];
        // } else {
        //   this.previousParam = undefined;
        // }
      });
    this.locationStrate.onPopState((result) => {
    // locationback からの時だけここにくる
      console.log(">> locationback :");
      this.history.pop();
        // this.isFromLocationBack = true;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log(">> NavigationEnd page :", event?.url);  // 遷移したページurl取得
        console.log(">> Page history :", this.history);

        if(!window.DW_GA_TID || !gtag) return;
        console.log("ga send page :" , event?.url, event?.url, this.history[this.history.length - 1])
        gtag('event', 'page_view', {
          page_title: this.history[this.history.length - 1],
          page_location: event?.url || "",
          page_path: event?.url || ""
        });
        // this.history.push(event.urlAfterRedirects);
      }
    });
  }

  push(url: string, param: {[key:string]: any} | null = null, replace: boolean = false) {
    const o = this;
    let opt: NavigationExtras = {};
    if(param) {
      opt["state"] = param;
    }
    if(replace) {
      opt["replaceUrl"] = true;
    }
    opt["queryParamsHandling"] = "merge";
    opt["queryParams"] = o.queryP;

    this.router.navigate([url], opt);
    this.history.push(url);
  }

  back(): void {
    this.history.pop();
    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl("/");
    }
  }
}